/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class DatesRoute extends Route {
  // Services
  @service
  dates;

  @service
  session;

  @service
  store;

  queryParams = {
    year: {
      refreshModel: true,
    },
  };

  model(params) {
    let defaultYear = moment().year();
    let academicYear = this.get('dates.currentAcademicYear');
    let schoolId = this.get('session.activeSchool');
    if (!isEmpty(academicYear)) {
      defaultYear = academicYear;
    }
    let startYear = params.year || defaultYear;
    let { from, to } = this.dates.getYearBounds(startYear);
    let year = startYear.toString();

    return hash({
      year: startYear,
      from,
      to,
      dates: this.store.query('date', { from, to }),
      timeframes: this.store.query('timeframe', { schoolId, year }),
    });
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    controller.set('year', model.year);
    if (model.dates.length < 365) {
      // Generate missing dates
      controller.generateDates(model);
    }

    if (model.timeframes.length) {
      let timeframesArray = model.timeframes
        .slice()
        .sort((a, b) =>
          a.startDateUnix > b.startDateUnix
            ? 1
            : a.startDateUnix < b.startDateUnix
              ? -1
              : 0,
        );
      controller.set('timeframes', timeframesArray);
    } else {
      // Create an empty timeframe if we have none
      let properties = {
        schoolId: this.get('session.school'),
        year: model.year.toString(),
      };
      controller.set('timeframes', [
        this.store.createRecord('timeframe', properties),
      ]);
    }
  }

  resetController(controller, isExiting) {
    if (isExiting) {
      // Clean up the new, unsaved timeframe when we exit the route
      // in case it gets picked up from the store by another route
      controller.cleanupTimeframes();
    }
  }
}
